const state = {
	url_api: `${process.env.VUE_APP_PATH_API}`,
	url_web: `${process.env.VUE_APP_PATH_WEB}`,
};

export default state;
